.pdpBrandAndTag {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
}

.pdpCardWrapper {
  max-width: 1496px;
  width: 100%;
  margin: 0 auto 16px;
}

.pdpCardContainer {
  display: grid;
  gap: 0;
  grid-template-columns: minmax(100%, max-content);
  margin-bottom: 16px;
}

.pdpCardImage {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-right: auto;
  margin-left: auto;
}

.productImgContainer {
  width: auto;
  height: auto;
  margin: 0px;
  position: relative;

  img {
    max-width: 100dvw;
    width: auto;
    height: auto;
    aspect-ratio: 1;
  }
}

.breadcrumbs {
  margin: 8px 16px 16px;
}

.specialBadgeContainer {
  position: absolute;
  top: 16px;
  right: 16px;
}

.specialIcon {
  margin-top: 4px;
  align-self: flex-start;
}

.pdpCardDetails {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-content: center;
  margin-right: auto;
  margin-left: auto;
  width: 100%;
  padding: 8px 16px 0;
}

.pdpNamesAndPrices {
  display: grid;
  grid-template-columns: 60% calc(40% - 8px);
  gap: 8px;
}

.pdpCardContainerPrice {
  display: flex;
  flex-flow: column;
  align-items: flex-end;
}

.pdpCardPrice {
  display: flex;
  gap: 8px;
  align-items: center;
}

.productDetailCardSpecialsText {
  color: var(--colors-info-main);
}

.pdpCardSpecials {
  display: flex;
  flex-direction: row;
  gap: 8px;
  margin-top: 8px;
  align-items: center;
  color: var(--colors-info-main);
  width: 100%;
  text-overflow: ellipsis;

  p {
    flex-shrink: 50;
  }

  svg path {
    fill: var(--colors-info-main);
  }
}

.pdpWeightSelectorWrapper {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: var(--colors-grays-white);
  padding: 16px;
  z-index: var(--z-pdp-weight-selector);
}

.janeGoldContainer {
  margin-top: 24px;
}

.janeGoldHeader {
  display: flex;
  gap: 8px;
  align-items: center;
}

@media (--reefer-media-tablet-min) {
  .pdpWeightSelectorWrapper {
    position: initial;
    padding: 0;
    margin-top: 24px;
  }

  .pdpCardContainer {
    gap: 48px;
    margin-bottom: 24px;
  }

  .breadcrumbs {
    margin: 12px 0 16px;
  }

  .productImgContainer {
    height: 644px;
    width: 644px;

    img {
      border-radius: var(--border-radius-sm);
      max-height: 644px;
      max-width: 644px;
    }
  }

  .specialBadgeContainer {
    position: absolute;
    top: 24px;
    right: 24px;
  }

  .pdpCardDetails {
    padding: 0;
  }
}

@media (width > 1190px) {
  .pdpCardContainer {
    grid-template-columns: 644px minmax(40%, max-content);
  }
}

.compareDesktopButton {
  display: none;
}

@media (--reefer-media-tablet-min) {
  .compareDesktopButton {
    display: block;
    position: absolute;
    right: 16px;
    bottom: 16px;
  }

  /** Raised above image pagination */
  .compareDesktopButton__raised {
    bottom: calc(16px + 30px + 8px);
  }
}
